<!-- 分时配置查询 -->
<template>
  <div class="app-container">
    <div class="app-content">
      <el-card class="timeshare-page" shadow="never">
        <template #header>
          <el-form inline size="small">
            <el-form-item :label="$t('text.pzmc')">
              <el-input v-model="queryParams.name" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
            <el-form-item :label="$t('text.sfmr')">
              <el-select v-model="queryParams.isdef" clearable placeholder="" @keyup.enter.native="handleSearch">
                <el-option :label="$t('text.s')" :value="true" />
                <el-option :label="$t('text.fou')" :value="false" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" :loading="table.loading" @click="handleSearch">{{ $t('button.cx') }}</el-button>
              <el-button type="primary" icon="el-icon-plus" @click="addDialog.visible = true">{{ $t('button.xzpz') }}</el-button>
            </el-form-item>
          </el-form>
        </template>
        <template #default>
          <div
            v-loading="table.loading"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.7)"
            class="card-list"
          >
            <div v-for="item in table.data" :key="item.id" class="timeshare-card" :class="{ 'is-default': item.isdef === 1 }">
              <div class="card-header">
                <div class="card-title">
                  <overflow-tip :content="item.name" />
                  <span v-if="item.isdef === 1" class="card-tag">{{ $t('text.default') }}</span>
                </div>
                <el-dropdown @command="handleRowOperate($event, item)">
                  <el-button type="text" size="mini" class="card-operate">
                    {{ $t('text.cz') }}<i class="el-icon-arrow-down el-icon--right" />
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="update" icon="el-icon-edit" style="color: var(--warning-color);">{{ $t('button.bj') }}</el-dropdown-item>
                    <el-dropdown-item command="delete" icon="el-icon-delete" style="color: var(--danger-color);" divided>{{ $t('button.sc') }}</el-dropdown-item>
                    <el-dropdown-item command="def" icon="el-icon-orange" style="color: var(--primary-color);" divided>{{ $t('button.mr') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <ul class="card-body">
                <li>
                  <span class="card-label">{{ $t('text.jsjd') }}</span>
                  <span class="card-value">{{ formateTimeRange(item.sharp) }}</span>
                </li>
                <li>
                  <span class="card-label">{{ $t('text.fsjd') }}</span>
                  <span class="card-value">{{ formateTimeRange(item.peak) }}</span>
                </li>
                <li>
                  <span class="card-label">{{ $t('text.psjd') }}</span>
                  <span class="card-value">{{ formateTimeRange(item.flat) }}</span>
                </li>
                <li>
                  <span class="card-label">{{ $t('text.gsjd') }}</span>
                  <span class="card-value">{{ formateTimeRange(item.valley) }}</span>
                </li>
                <li>
                  <span class="card-label">{{ $t('text.dvalleyTimeRange') }}</span>
                  <span class="card-value">{{ formateTimeRange(item.dvalley) }}</span>
                </li>
                <li>
                  <span class="card-label">{{ $t('text.fgwglj') }}</span>
                  <template v-if="item.remark">
                    <span class="card-value">
                      <el-link :href="item.remark" type="primary" target="_blank">链接</el-link>
                    </span>
                  </template>
                  <template v-else>
                    <span class="card-value">{{ '--' }}</span>
                  </template>
                </li>
              </ul>
            </div>
            <div v-if="!table.data.length" style="grid-column: 1 / span 5;">
              <div class="table-no-data" style="background-size: 15%;" />
            </div>
          </div>
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="page.totalPage"
            :current-page.sync="page.pageNum"
            :page-size.sync="page.pageSize"
            @current-change="getTableData"
          />
        </template>
      </el-card>

      <!-- 新增分时费率弹窗 -->
      <el-dialog
        width="680px"
        append-to-body
        :title="$t('text.xzfsfl')"
        :visible.sync="addDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @closed="handleAddDialogClosed"
      >
        <el-form
          ref="addForm"
          label-width="120px"
          size="small"
          :model="addDialog.formData"
          :rules="addDialog.formRules"
        >
          <el-form-item :label="$t('text.fsflmc')" prop="name">
            <el-input v-model="addDialog.formData.name" :placeholder="$t('text.qsrfsflmc')" clearable />
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTimePeriod">
            <div style="display: flex; align-items: center;">
              <el-date-picker
                v-model="addDialog.formData.startdate"
                type="date"
                :placeholder="$t('placeholder.kssj')"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
              <div style="margin: 0 8px;color: var(--primary-color);">至</div>
              <el-date-picker
                v-model="addDialog.formData.enddate"
                type="date"
                :placeholder="$t('placeholder.jssj')"
                value-format="yyyy-MM-dd"
                style="margin-top: 0;"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('text.fgwglj')" prop="remark">
            <el-input v-model="addDialog.formData.remark" :placeholder="$t('text.qsrfgwglj')" clearable />
          </el-form-item>
          <el-form-item :label="$t('text.jsjd')" prop="sharp">
            <time-range-picker ref="addSharpPicker" v-model="addDialog.formData.sharp" time-range-name="尖" />
          </el-form-item>
          <el-form-item :label="$t('text.fsjd')" prop="peak">
            <time-range-picker ref="addPeakPicker" v-model="addDialog.formData.peak" time-range-name="峰" />
          </el-form-item>
          <el-form-item :label="$t('text.psjd')" prop="flat">
            <time-range-picker ref="addFlatPicker" v-model="addDialog.formData.flat" time-range-name="平" />
          </el-form-item>
          <el-form-item :label="$t('text.gsjd')" prop="valley">
            <time-range-picker ref="addValleyPicker" v-model="addDialog.formData.valley" time-range-name="谷" />
          </el-form-item>
          <el-form-item :label="$t('text.dvalleyTimeRange')" prop="dvalley">
            <time-range-picker ref="addDValleyPicker" v-model="addDialog.formData.dvalley" time-range-name="深谷" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="addDialog.visible = false">{{ $t('button.qx') }}</el-button>
          <el-button type="primary" :loading="addDialog.loading" @click="handleAddSubmit">{{ $t('button.qr') }}</el-button>
        </template>
      </el-dialog>

      <!-- 编辑分时费率弹窗 -->
      <el-dialog
        width="700px"
        append-to-body
        :title="$t('text.bjfsfl')"
        :visible.sync="updateDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @closed="handleUpdateDialogClosed"
      >
        <el-form
          ref="updateForm"
          label-width="120px"
          size="small"
          :model="updateDialog.formData"
          :rules="updateDialog.formRules"
        >
          <el-form-item :label="$t('text.fsflmc')" prop="name">
            <el-input v-model="updateDialog.formData.name" :placeholder="$t('text.qsrfsflmc')" clearable />
          </el-form-item>
          <el-form-item label="生效时间" prop="effectiveTimePeriod">
            <div style="display: flex; align-items: center;">
              <el-date-picker
                v-model="updateDialog.formData.startdate"
                type="date"
                :placeholder="$t('placeholder.kssj')"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              />
              <div style="margin: 0 8px;color: var(--primary-color);">至</div>
              <el-date-picker
                v-model="updateDialog.formData.enddate"
                type="date"
                :placeholder="$t('placeholder.jssj')"
                value-format="yyyy-MM-dd"
                style="margin-top: 0;"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('text.fgwglj')" prop="remark">
            <el-input v-model="updateDialog.formData.remark" :placeholder="$t('text.qsrfgwglj')" clearable />
          </el-form-item>
          <el-form-item :label="$t('text.jsjd')" prop="sharp" style="margin-bottom: 0;">
            <time-range-picker ref="updateSharpPicker" v-model="updateDialog.formData.sharp" time-range-name="尖" />
          </el-form-item>
          <el-form-item :label="$t('text.fsjd')" prop="peak" style="margin-bottom: 0;">
            <time-range-picker ref="updatePeakPicker" v-model="updateDialog.formData.peak" time-range-name="峰" />
          </el-form-item>
          <el-form-item :label="$t('text.psjd')" prop="flat" style="margin-bottom: 0;">
            <time-range-picker ref="updateFlatPicker" v-model="updateDialog.formData.flat" time-range-name="平" />
          </el-form-item>
          <el-form-item :label="$t('text.gsjd')" prop="valley" style="margin-bottom: 0;">
            <time-range-picker ref="updateValleyPicker" v-model="updateDialog.formData.valley" time-range-name="谷" />
          </el-form-item>
          <el-form-item :label="$t('text.dvalleyTimeRange')" prop="dvalley" style="margin-bottom: 0;">
            <time-range-picker ref="updateDValleyPicker" v-model="updateDialog.formData.dvalley" time-range-name="深谷" />
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="updateDialog.visible = false">{{ $t('button.qx') }}</el-button>
          <el-button type="primary" :loading="updateDialog.loading" @click="handleUpdateSubmit">{{ $t('button.qr') }}</el-button>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { PageQueryTimesShare, AddTimesShare, DeleteTimesShare, UpdateTimesShare, SetDefaultTimeShare } from '@/api/Meter'
import TimeRangePicker from './components/TimeRangePicker.vue'
import dayjs from 'dayjs'
/** 标题溢出气泡提示：文字溢出时显示完整标题 */
const OverflowTip = {
  name: 'OverflowTip',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      /** 标题是否溢出 */
      overflow: false
    }
  },
  mounted () {
    this.checkOverflow()
    this.$nextTick(this.checkOverflow)
    window.addEventListener('resize', this.checkOverflow)
  },
  updated () {
    this.$nextTick(this.checkOverflow)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.checkOverflow)
  },
  methods: {
    /** 检测标题文字是否溢出 */
    checkOverflow () {
      const textEl = this.$refs.text
      const overflow = textEl ? textEl.scrollWidth > textEl.clientWidth : false
      if (overflow !== this.overflow) {
        this.overflow = overflow
      }
    }
  },
  render (h) {
    return h('el-tooltip', {
      props: {
        content: this.content,
        placement: 'top',
        disabled: !this.overflow
      }
    }, [
      h('span', {
        ref: 'text',
        class: 'card-name',
        attrs: { title: this.content }
      }, this.content)
    ])
  }
}

export default {
  components: {
    /** 标题溢出气泡提示 */
    OverflowTip,
    /** 时段选择器 */
    TimeRangePicker
  },
  data () {
    /** 添加分时费率时的生效时间验证规则 */
    const addValidateEffectiveTimePeriod = (rule, value, callback) => {
      if (!this.addDialog.formData.startdate) {
        callback(new Error('请选择生效开始时间'))
      } else if (!this.addDialog.formData.enddate) {
        callback(new Error('请选择生效结束时间'))
      } else if (this.addDialog.formData.startdate > this.addDialog.formData.enddate) {
        callback(new Error('生效结束时间不能早于生效开始时间'))
      } else {
        callback()
      }
    }
    /** 更新分时费率时的生效时间验证规则 */
    const updateValidateEffectiveTimePeriod = (rule, value, callback) => {
      if (!this.updateDialog.formData.startdate) {
        callback(new Error('请选择生效开始时间'))
      } else if (!this.updateDialog.formData.enddate) {
        callback(new Error('请选择生效结束时间'))
      } else if (this.updateDialog.formData.startdate > this.updateDialog.formData.enddate) {
        callback(new Error('生效结束时间不能早于生效开始时间'))
      } else {
        callback()
      }
    }

    return {

      /** 查询参数 */
      queryParams: {
        /** 名称 */
        name: '',
        /** 是否默认 */
        isdef: null,
      },

      /** 表格数据 */
      table: {
        /** 加载中 */
        loading: false,
        /** 表格数据 */
        data: [],
      },

      /** 分页数据 */
      page: {
        /** 当前页 */
        pageNum: 1,
        /** 每页条数 */
        pageSize: 10,
        /** 总页数 */
        totalPage: 0,
      },

      /** 新增弹窗数据 */
      addDialog: {
        /** 显示/隐藏弹窗 */
        visible: false,
        /** 提交中 */
        loading: false,
        /** 新增表单数据 */
        formData: {
          /** 分时费率名称 */
          name: '',
          /** 起始日期 */
          startdate: '',
          /** 结束日期 */
          enddate: '2099-12-31',
          /** 尖费率时段 */
          sharp: [],
          /** 峰费率时段 */
          peak: [],
          /** 平费率时段 */
          flat: [],
          /** 谷费率时段 */
          valley: [],
          /** 深谷费率时段 */
          dvalley: [],
          /** 发改委公告链接 */
          remark: ''
        },
        /** 新增表单验证规则 */
        formRules: {
          name: [
            { required: true, message: this.$t('text.qsrfsflmc'), trigger: 'blur' }
          ],
          effectiveTimePeriod: [
            { required: true, validator: addValidateEffectiveTimePeriod, trigger: 'change' }
          ]
        }
      },

      /** 更新弹窗数据 */
      updateDialog: {
        /** 显示/隐藏弹窗 */
        visible: false,
        /** 更新表单数据 */
        formData: {
          /** 主键 */
          id: '',
          /** 分时费率名称 */
          name: '',
          /** 起始日期 */
          startdate: '',
          /** 结束日期 */
          enddate: '',
          /** 尖费率时段 */
          sharp: [],
          /** 峰费率时段 */
          peak: [],
          /** 平费率时段 */
          flat: [],
          /** 谷费率时段 */
          valley: [],
          /** 深谷费率时段 */
          dvalley: [],
          /** 发改委公告链接 */
          remark: ''
        },
        /** 更新表单验证规则 */
        formRules: {
          name: [
            { required: true, message: this.$t('text.qsrfsflmc'), trigger: 'blur' }
          ],
          effectiveTimePeriod: [
            { required: true, validator: updateValidateEffectiveTimePeriod, trigger: 'change' }
          ]
        },
        /** 更新弹窗是否初始化 */
        dialogIsInit: false
      }
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {

    /** 格式化时间范围 */
    formateTimeRange (cellValue) {
      let result = '--'
      if (!cellValue) {
        return result
      }
      const timeRange = JSON.parse(cellValue)
      if (timeRange.length > 0) {
        const timeRangeString = timeRange.map(item => {
          let { s, e } = item
          s = `${s}`.padStart(2, '0')
          e = `${e}`.padStart(2, '0')
          return `${s}:00-${e}:00`
        })
        result = timeRangeString.join(',')
      }
      return result
    },

    /** 查询 */
    handleSearch () {
      this.page.pageNum = 1
      this.getTableData()
    },

    /** 获取表格数据 */
    getTableData () {
      this.table.loading = true
      this.table.data = []
      const queryParams = {
        name: this.queryParams.name,
        isdef: this.queryParams.isdef !== '' ? this.queryParams.isdef : null,
      }
      PageQueryTimesShare({
        page: this.page.pageNum,
        perPage: this.page.pageSize,
        whereCondition: JSON.stringify(queryParams)
      }).then(response => {
        this.table.data = response.data.queryResults || []
        this.page.totalPage = response.data.totalCount || 0
        this.table.loading = false
      }).catch(() => {
        this.table.loading = false
      })
    },

    /** 行操作 */
    handleRowOperate (command, row) {
      if (command === 'update') {
        this.handleUpdateRow(row)
      } else if (command === 'delete') {
        this.handleDeleteSubmit(row.id)
      } else if (command === 'def') {
        this.handleDefaultSubmit(row.id)
      }
    },

    /** 更新分时费率 */
    handleUpdateRow (row) {
      const timeShareRate = JSON.parse(JSON.stringify(row))
      this.updateDialog.formData.id = timeShareRate.id
      this.updateDialog.formData.name = timeShareRate.name
      this.updateDialog.formData.startdate = dayjs(timeShareRate.startTime).format('YYYY-MM-DD')
      this.updateDialog.formData.enddate = dayjs(timeShareRate.endTime).format('YYYY-MM-DD')
      this.updateDialog.formData.sharp = JSON.parse(timeShareRate.sharp).map(({ s, e }) => { return { start: `${`${s}`.padStart(2, '0')}:00`, end: `${`${e}`.padStart(2, '0')}:00` } })
      this.updateDialog.formData.peak = JSON.parse(timeShareRate.peak).map(({ s, e }) => { return { start: `${`${s}`.padStart(2, '0')}:00`, end: `${`${e}`.padStart(2, '0')}:00` } })
      this.updateDialog.formData.flat = JSON.parse(timeShareRate.flat).map(({ s, e }) => { return { start: `${`${s}`.padStart(2, '0')}:00`, end: `${`${e}`.padStart(2, '0')}:00` } })
      this.updateDialog.formData.valley = JSON.parse(timeShareRate.valley).map(({ s, e }) => { return { start: `${`${s}`.padStart(2, '0')}:00`, end: `${`${e}`.padStart(2, '0')}:00` } })
      this.updateDialog.formData.dvalley = JSON.parse(timeShareRate.dvalley).map(({ s, e }) => { return { start: `${`${s}`.padStart(2, '0')}:00`, end: `${`${e}`.padStart(2, '0')}:00` } })
      this.updateDialog.formData.remark = timeShareRate.remark
      if (this.updateDialog.dialogIsInit) {
        this.$refs.updateSharpPicker.setFormValue(this.updateDialog.formData.sharp)
        this.$refs.updatePeakPicker.setFormValue(this.updateDialog.formData.peak)
        this.$refs.updateFlatPicker.setFormValue(this.updateDialog.formData.flat)
        this.$refs.updateValleyPicker.setFormValue(this.updateDialog.formData.valley)
        this.$refs.updateDValleyPicker.setFormValue(this.updateDialog.formData.dvalley)
      } else {
        this.updateDialog.dialogIsInit = true
      }
      this.updateDialog.visible = true
    },

    /** 打开新增弹窗 */
    handleOpenAddDialog () {
      this.resetForm()
      this.addDialog.visible = true
    },

    /** 新增弹窗关闭时重置表单 */
    handleAddDialogClosed () {
      this.addDialog.formData.name = ''
      this.addDialog.formData.startdate = ''
      this.addDialog.formData.enddate = '2099-12-31'
      this.addDialog.formData.sharp = []
      this.addDialog.formData.peak = []
      this.addDialog.formData.flat = []
      this.addDialog.formData.valley = []
      this.addDialog.formData.dvalley = []
      this.addDialog.formData.remark = ''

      this.$refs.addSharpPicker.setFormValue([])
      this.$refs.addPeakPicker.setFormValue([])
      this.$refs.addFlatPicker.setFormValue([])
      this.$refs.addValleyPicker.setFormValue([])
      this.$refs.addDValleyPicker.setFormValue([])
    },

    /** 更新弹窗关闭时重置表单 */
    handleUpdateDialogClosed () {
      this.updateDialog.formData.id = ''
      this.updateDialog.formData.name = ''
      this.updateDialog.formData.startdate = ''
      this.updateDialog.formData.enddate = ''
      this.updateDialog.formData.sharp = []
      this.updateDialog.formData.peak = []
      this.updateDialog.formData.flat = []
      this.updateDialog.formData.valley = []
      this.updateDialog.formData.dvalley = []
      this.updateDialog.formData.remark = ''
      this.$refs.updateSharpPicker.setFormValue([])
      this.$refs.updatePeakPicker.setFormValue([])
      this.$refs.updateFlatPicker.setFormValue([])
      this.$refs.updateValleyPicker.setFormValue([])
      this.$refs.updateDValleyPicker.setFormValue([])
    },

    /** 校验分时费率 */
    checkTimeOfUseRates (timeRange) {
      let checkResult = true
      try {
        const { sharp, peak, flat, valley, dvalley } = timeRange
        const timeRanges = [...sharp, ...peak, ...flat, ...valley, ...dvalley]
        if (timeRanges.length === 0) {
          throw new Error('分时费率必须存在时间段')
        }
        if (!timeRanges.find(item => item.start === '00:00') || !timeRanges.find(item => item.end === '24:00')) {
          throw new Error('必须存在00:00和24:00')
        }
        if (timeRanges.filter(item => item.start === '' || item.end === '').length > 0) {
          throw new Error('存在为空的时间')
        }
        if (timeRanges.filter(item => Number(item.start.split(':')[0]) >= Number(item.end.split(':')[0])).length > 0) {
          throw new Error('存在开始时间大于结束时间的无效时间段')
        }
        const timeHours = [... new Set(timeRanges.map(item => Number(item.start.split(':')[0]))), ... new Set(timeRanges.map(item => Number(item.end.split(':')[0])))]
        const uniqueTimeHours = Array.from(new Set(timeHours)).sort((p, n) => p - n)

        for (let index = 0; index < uniqueTimeHours.length - 1; index++) {
          const start = `${`${uniqueTimeHours[index]}`.padStart(2, '0')}:00`
          if (timeRanges.filter(item => item.start === start).length > 1) {
            throw new Error(`存在多个以${start}开始的时间段`)
          }
        }
        for (let index = 1; index < uniqueTimeHours.length; index++) {
          const end = `${`${uniqueTimeHours[index + 1]}`.padStart(2, 0)}:00`
          if (timeRanges.filter(item => item.end === end).length > 1) {
            throw new Error(`存在多个以${end}结尾的时间段`)
          }
        }
        for (let index = 0; index < uniqueTimeHours.length - 1; index++) {
          const start = `${`${uniqueTimeHours[index]}`.padStart(2, '0')}:00`
          const end = `${`${uniqueTimeHours[index + 1]}`.padStart(2, 0)}:00`
          const rangeList = timeRanges.filter(item => item.start === start && item.end === end)
          if (rangeList.length === 0) {
            throw new Error(`遗漏了时间段 ${start} ~ ${end}`)
          } else if (rangeList.length > 1) {
            throw new Error(`重复了时间段 ${start} ~ ${end}`)
          }
        }
      } catch ({ message }) {
        this.$message({ message, type: 'error' })
        checkResult = false
      }
      return checkResult
    },

    /** 格式化提交参数 */
    formatSubmitParam (timeRange, id) {
      const submitData = {
        name: timeRange.name,
        starttime: timeRange.startdate,
        endtime: timeRange.enddate,
        sharp: timeRange.sharp.map(item => { return { s: item.start.split(':')[0], e: item.end.split(':')[0] } }),
        peak: timeRange.peak.map(item => { return { s: item.start.split(':')[0], e: item.end.split(':')[0] } }),
        flat: timeRange.flat.map(item => { return { s: item.start.split(':')[0], e: item.end.split(':')[0] } }),
        valley: timeRange.valley.map(item => { return { s: item.start.split(':')[0], e: item.end.split(':')[0] } }),
        dvalley: timeRange.dvalley.map(item => { return { s: item.start.split(':')[0], e: item.end.split(':')[0] } }),
        remark: timeRange.remark
      }
      if (id) {
        submitData.id = id
      }
      return submitData
    },

    /** 新增分时费率 */
    handleAddSubmit () {
      this.$refs.addForm.validate(valid => {
        if (valid && this.checkTimeOfUseRates(this.addDialog.formData)) {
          this.addDialog.loading = true
          const submitData = this.formatSubmitParam(this.addDialog.formData, null)
          AddTimesShare(submitData).then(() => {
            this.$message({ message: this.$t('notice.tjcg'), type: 'success' })
            this.getTableData()
            this.addDialog.visible = false
          }).catch(() => {
            this.$message({ message: this.$t('notice.tjsb'), type: 'error' })
          }).finally(() => {
            this.addDialog.loading = false
          })
        }
      })
    },

    /** 删除分时费率 */
    handleDeleteSubmit (id) {
      // 确认删除
      this.$confirm(this.$t('notice.qdsc'), this.$t('notice.tips'), {
        confirmButtonText: this.$t('notice.yes'),
        cancelButtonText: this.$t('notice.no'),
        type: 'warning'
      }).then(() => {
        DeleteTimesShare({ id: id }).then(() => {
          this.$message({ message: this.$t('notice.sccg'), type: 'success' })
          this.getTableData()
        }).catch(() => {
          this.$message({ message: this.$t('notice.scsb'), type: 'error' })
        })
      })
    },

    /** 编辑分时费率 */
    handleUpdateSubmit () {
      this.$refs.updateForm.validate(valid => {
        if (valid && this.checkTimeOfUseRates(this.updateDialog.formData)) {
          this.updateDialog.loading = true
          const submitData = this.formatSubmitParam(this.updateDialog.formData, this.updateDialog.formData.id)
          console.log(submitData)
          UpdateTimesShare(submitData).then(() => {
            this.$message({ message: this.$t('notice.tjcg'), type: 'success' })
            this.getTableData()
            this.updateDialog.visible = false
          }).catch(() => {
            this.$message({ message: this.$t('notice.tjsb'), type: 'error' })
          }).finally(() => {
            this.updateDialog.loading = false
          })
        }
      })
    },

    /** 设置为默认分时费率 */
    handleDefaultSubmit (id) {
      // 确认设置为默认
      this.$confirm('确认设置为默认分时费率吗？', this.$t('notice.tips'), {
        confirmButtonText: this.$t('notice.yes'),
        cancelButtonText: this.$t('notice.no'),
        type: 'warning'
      }).then(() => {
        SetDefaultTimeShare({ timeShareId: id }).then(() => {
          this.$message({ message: this.$t('notice.sccg'), type: 'success' })
          this.getTableData()
        }).catch(() => {
          this.$message({ message: this.$t('notice.scsb'), type: 'error' })
        })
      })
    }
  }
}
</script>

<style scoped>
.timeshare-page {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #1d3666;
  border-color: #1d3666;
}

.timeshare-page >>>.el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
}

.timeshare-page >>>.el-card__header .el-form {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.timeshare-page >>>.el-card__header .el-form-item {
  margin-bottom: 0;
}

.timeshare-page >>>.el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 10px 20px 0;
  box-sizing: border-box;
}

/* 卡片列表：自适应网格布局，简洁大气 */
.timeshare-page >>>.el-card__body .card-list {
  width: 100%;
  height: calc(100% - 50px);
  padding: 4px 0 10px;
  box-sizing: border-box;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
  align-content: start;
}

/* 分时卡片 */
.timeshare-page >>>.el-card__body .timeshare-card {
  background: linear-gradient(180deg, rgba(26, 74, 110, 0.55), rgba(20, 70, 109, 0.55));
  border: 1px solid rgba(28, 193, 151, 0.18);
  border-radius: 8px;
  padding: 14px 16px 10px;
  box-sizing: border-box;
  transition: all 0.2s ease;
}
.timeshare-page >>>.el-card__body .timeshare-card.timeshare-card:hover {
  border-color: rgba(28, 193, 151, 0.55);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px);
}

/* 默认费率卡片：深青绿高亮背景，强调与非默认区分 */
.timeshare-page >>>.el-card__body .timeshare-card.is-default.timeshare-card.is-default {
  background: linear-gradient(180deg, rgba(28, 193, 151, 0.42), rgba(12, 55, 103, 0.75));
  border-color: rgba(28, 193, 151, 0.85);
  box-shadow: 0 0 18px rgba(28, 193, 151, 0.28);
}
.timeshare-page >>>.el-card__body .timeshare-card.is-default:hover {
  border-color: #1cc197;
  box-shadow: 0 6px 22px rgba(28, 193, 151, 0.38);
}

/* 卡片头部 */
.timeshare-page >>>.el-card__body .timeshare-card .card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.timeshare-page >>>.el-card__body .timeshare-card .card-header .card-title {
  display: flex;
  align-items: center;
  min-width: 0;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-header .card-title .card-name {
  min-width: 0;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-header .card-title .card-tag {
  flex-shrink: 0;
  margin-left: 8px;
  padding: 0 6px;
  font-size: 12px;
  line-height: 18px;
  color: #1cc197;
  border: 1px solid rgba(28, 193, 151, 0.5);
  border-radius: 2px;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-header .card-operate {
  color: #1cc197;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-header .card-operate:hover {
  color: #45d9b0;
}

/* 卡片时间内容 */
.timeshare-page >>>.el-card__body .timeshare-card .card-body {
  list-style: none;
  margin: 0;
  padding: 8px 0 0;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-body li {
  display: flex;
  align-items: flex-start;
  padding: 5px 0;
  flex-wrap: wrap;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-body li .card-label {
  width: 100px;
  flex-shrink: 0;
  color: #1cc197;
  font-size: 13px;
}
.timeshare-page >>>.el-card__body .timeshare-card .card-body li .card-value {
  flex: 1;
  min-width: 0;
  color: #d6e6f8;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  word-break: break-all;
  white-space: normal;
  line-height: 1.5;
}
.timeshare-page >>>.el-card__body .el-pagination {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>
